// src/pages/training-videos-library/components/CategoryFilter.jsx
// Shows category filter buttons.
// If isAdmin=true, shows a ⚙ "Gérer" button to open CategoryManagerModal.

import React from 'react';
import Icon from '../../../components/AppIcon';

const DEFAULT_ICONS = {
  'Tous':           'Grid3x3',
  'Procedures':     'Stethoscope',
  'Equipment':      'Wrench',
  'Safety':         'Shield',
  'Software':       'Monitor',
  'Clinical':       'Activity',
  'Administration': 'FileText',
};

const CategoryFilter = ({
  categories,
  selectedCategory,
  onCategoryChange,
  isAdmin = false,
  onManageClick,
}) => {
  const getIcon = (cat) =>
    cat.icon_name || DEFAULT_ICONS[cat.name] || 'Folder';

  return (
    <div className="flex flex-wrap items-center gap-2">
      {categories?.map((category) => (
        <button
          key={category?.id}
          onClick={() => onCategoryChange(category?.id)}
          className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
            selectedCategory === category?.id
              ? 'bg-primary text-primary-foreground shadow-sm'
              : 'bg-card text-foreground border border-border hover:bg-muted'
          }`}
        >
          <Icon name={getIcon(category)} size={18} />
          <span>{category?.name}</span>
          <span
            className={`px-2 py-0.5 text-xs rounded-full ${
              selectedCategory === category?.id
                ? 'bg-primary-foreground/20 text-primary-foreground'
                : 'bg-muted text-muted-foreground'
            }`}
          >
            {category?.count}
          </span>
        </button>
      ))}

      {/* Admin-only manage button */}
      {isAdmin && (
        <button
          onClick={onManageClick}
          className="flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm font-medium text-muted-foreground border border-dashed border-border hover:border-primary/40 hover:text-primary hover:bg-primary/5 transition-all duration-200"
          title="Gérer les catégories"
        >
          <Icon name="Settings2" size={15} />
          <span>Gérer</span>
        </button>
      )}
    </div>
  );
};

export default CategoryFilter;